import { FC } from "react";
import { FaStar } from "react-icons/fa";

const GradientIcon:FC = () => {
  return (
    <svg width="30" height="30" className="flex items-center justify-center">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#e3722d", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#f4d549", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <FaStar
        style={{
          fill: "url(#gradient)",
          fontSize: '2rem',
        }}
      />
    </svg>
  );
};

export default GradientIcon;
